import Popconfirm from 'antd/lib/popconfirm';

export default Popconfirm;
